import React, { useEffect, useMemo, useState } from 'react';
import styled from 'styled-components';

import { Link } from 'react-router-dom';
import Txt from '../atoms/Txt';

import Row from '../atoms/FlexRow';
import Col from '../atoms/FlexColumn';
import ImgFit from '../atoms/ImgFit';
import HorSpacer from '../atoms/HorSpacer';
import theme from '../../constants/AppTheme';
import Icon from '../atoms/Icon';
import { getProduct } from '../../database/repositories/ProductRepository';
import { TransctionEventBlockInfo } from '../../utils/constants';
import { timestampToDate } from '../../database/utils/firebase';
import { normalizeMoney } from '../../utils/util';

const MainContainer = styled.div`
  margin: 10px 0;

  .chevron:hover {
    cursor: pointer;
  }
`;

const CoverContainer = styled.div`
  background-color: ${theme.dirtyWhite};
  border-radius: 15px;
  justify-content: space-between;
  display: flex;
  flex-direction: row;
  padding: 10px 40px;

  @media (max-width: 768px) {
    width: 360px;
  }
`;

const DetailsContainer = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${theme.gray};
  justify-content: space-between;
  margin-top: -20px;
  padding: 25px 10px 10px 10px;
  border-bottom-right-radius: 10px;
  border-bottom-left-radius: 10px;
  position: relative;
  z-index: -1;

  @media (max-width: 768px) {
    width: 360px;
  }
`;
const LinkButton = styled(Link)`
  display: flex;
  color: #ffff;
  font-weight: bold;
  margin-right: 10px;
  background-color: #28a745;
  padding: 8px 25px;
  border-radius: 10px;
`;
const ButtonPay = styled.div`
  display: flex;
  color: #ffff;
  font-weight: bold;
  margin-right: 10px;
  background-color: #28a745;
  padding: 8px 25px;
  border-radius: 10px;
`;

const EventCard = ({ event, info, iconBackground, iconColor }) => (
  <Row justify="flex-start" margin="5px">
    <HorSpacer size={50} />
    <Col align="flex-start">
      <Txt bold color="white">
        {timestampToDate(event.createdAt).toLocaleDateString('pt-br')}
      </Txt>
      <Txt bold color="white">
        {timestampToDate(event.createdAt).toLocaleTimeString('pt-br')}
      </Txt>
    </Col>
    <Icon faCode={info.iconCode} background={iconBackground} color={iconColor} margin="0 20px" />
    <Col align="flex-start">
      <Txt bold color="white">
        {info.description.toUpperCase()}
      </Txt>
      {info.details ? (
        <Txt size={14} color="white">
          {info.details}
        </Txt>
      ) : null}
    </Col>
  </Row>
);

function TransactionRow({ trans, finished = false }) {
  const [showEvents, setShowEvents] = useState(false);
  const [prod, setProduct] = useState(null);

  const mapEvent = (event) => ({ info: TransctionEventBlockInfo[event.type], event });
  const events = useMemo(() => trans.events.map(mapEvent), [trans]);
  const lastEvent = useMemo(() => events[events.length - 1], [events]);

  useEffect(() => {
    getProduct(trans.productID).then(setProduct).catch(console.error);
  }, [trans.productID]);

  if (prod) {
    return (
      <MainContainer>
        <CoverContainer>
          <Row>
            <div style={{ width: 150 }}>
              <Link to={`/produto/detalhes/${trans.productID}`}>
                <ImgFit src={prod.pictures[0]} alt="Foto do produto" />
              </Link>
            </div>
            <HorSpacer size={20} />
            <Col align="flex-start" style={{ paddingLeft: '-20px' }}>
              <Txt>{timestampToDate(lastEvent.event.createdAt).toLocaleDateString('pt-br')}</Txt>
              <Txt color={theme.red}>{prod.name.toUpperCase()}</Txt>
              <Txt color={theme.red}>{prod.condition.toUpperCase()}</Txt>
              <Txt bold color={theme.darkGray}>
                {normalizeMoney(trans.total)}
              </Txt>
            </Col>
          </Row>
          <Row>
            {/* <Icon faCode={lastEvent.info.iconCode} size={50} color={lastEvent.info.color} /> */}
            {/* <HorSpacer /> */}
            {/* <Txt color={lastEvent.info.color}>{lastEvent.info.description.toUpperCase()}</Txt> */}
            {/* <HorSpacer /> */}
            {trans.chargeUrl ? (
              <>
                {finished ? (
                  <ButtonPay>Fechado</ButtonPay>
                ) : (
                  <LinkButton onClick={() => window.open(trans.chargeUrl)}>Pagar</LinkButton>
                )}
              </>
            ) : (
              <></>
            )}

            <Icon
              faCode={`fas fa-chevron-${showEvents ? 'down' : 'up'}`}
              className="chevron"
              size={30}
              roundness="10px"
              onClick={() => setShowEvents(!showEvents)}
              padding={10}
              background={theme.softGray}
            />
            {/* </label> */}
          </Row>
        </CoverContainer>
        {showEvents && (
          <DetailsContainer id={`stats_del_${trans.id}`}>
            {events.map(({ info, event }, index) => (
              <EventCard
                event={event}
                info={info}
                iconBackground={index === events.length - 1 ? info.color : 'white'}
                iconColor={index === events.length - 1 ? theme.dirtyWhite : theme.gray}
              />
            ))}
          </DetailsContainer>
        )}
      </MainContainer>
    );
  }

  return null;
}

export default TransactionRow;
